import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik, Field, Form } from 'formik';
import { withTranslation } from 'react-i18next';
import { Prompt } from 'react-router';
import { Button, VerticalSpacer } from '@01_people/ui-library';
import SvgIcon from 'components/svg-icon';
import {
  SUBTYPE_BANK_STATEMENT,
  TYPE_ADDRESS,
  TYPE_ADDRESS_OLD
} from 'utils/constants';
import DocumentUploader from '../document-uploader';
import POASchema from './proof-of-address.schema';
import * as ActionCreators from '../../../redux/action';
import ProofOfAddressSC from './proof-of-address.styled';
import DocumentSelector from '../document-selector';
import DocumentStatusInfo from '../status-info';
import successIcon from '../../../assets/svg/circle-success.svg';
// import iconAddress from '../../../assets/svg/address.svg';
import iconAddress from '../../../assets/svg/id-card-icon.svg';

const initialFromValues = {
  typeOfDocument: SUBTYPE_BANK_STATEMENT,
  proofOfAddress: []
};

const ProofOfAddress = ({
  active,
  setActive,
  setInactive,
  approved,
  subtypes,
  devices,
  uploadKycDocument,
  t,
  showOnly,
  documents
}) => {
  const onFormSubmit = values => {
    uploadKycDocument({
      ...values,
      typeOfDocumentId: subtypes[values.typeOfDocument].id
    });
  };

  const currentDocument = documents
    ? documents.find(
        d => d.type === TYPE_ADDRESS || d.type === TYPE_ADDRESS_OLD
      )
    : null;
  const currentStatus = currentDocument ? currentDocument.status : 'unUploaded';

  return (
    <ProofOfAddressSC>
      <div className="container">
        <div className="kyc-inner-block">
          {currentStatus === 'unUploaded' ||
          currentStatus === 'rejectedByUser' ? (
            <>
              {active ? (
                <Formik
                  initialValues={initialFromValues}
                  validationSchema={POASchema}
                  onSubmit={onFormSubmit}
                  render={({
                    values,
                    setFieldValue,
                    setFieldTouched,
                    errors,
                    touched,
                    isSubmitting,
                    resetForm,
                    submitForm,
                    dirty
                  }) => (
                    <Form>
                      <Prompt when={dirty} message={t('kyc.leaveMessage')} />
                      <div className="row">
                        <div className="col title-col">
                          <div className="row">
                            <SvgIcon
                              icon={iconAddress}
                              alt="address_icon"
                              themed
                              active
                              styling="primary"
                            />
                            <h5 className="block-title">
                              {t('kyc.address.title')}
                            </h5>
                          </div>
                        </div>
                      </div>
                      <VerticalSpacer height="8px" />
                      <Field
                        name="typeOfDocument"
                        component={DocumentSelector}
                        type={TYPE_ADDRESS}
                        value={values.typeOfDocument}
                        onChange={document => {
                          resetForm(initialFromValues);
                          setFieldValue('typeOfDocument', document);
                        }}
                      />
                      <VerticalSpacer height="40px" />
                      <Field
                        component={DocumentUploader}
                        maxFiles={1}
                        name="proofOfAddress"
                        value={values.proofOfAddress}
                        devices={devices}
                        // onError={fieldError => {
                        //   setFieldError('proofOfAddress', fieldError);
                        // }}
                        onChange={files => {
                          setFieldValue('proofOfAddress', files);
                        }}
                        onTouch={fieldTouched => {
                          setFieldTouched('proofOfAddress', fieldTouched);
                        }}
                        errors={[t(errors.proofOfAddress)]}
                        touched={touched.proofOfAddress}
                        style={{ marginTop: '30px' }}
                        label=""
                        subLabel={t('kyc.address.heading1')}
                      />
                      <div className="save-wrapper">
                        <Button
                          customClass="close-btn"
                          styling="secondary"
                          label={t('kyc.closeButton')}
                          onClick={() => setInactive()}
                        />
                        <Button
                          styling="primary"
                          type="submit"
                          label={t('kyc.saveButton')}
                        />
                      </div>
                    </Form>
                  )}
                />
              ) : (
                <div className="title-row">
                  <div className="col title-col">
                    <div className="row">
                      <SvgIcon
                        icon={iconAddress}
                        alt="identity_icon"
                        themed
                        active
                        styling="primary"
                      />
                      {approved && (
                        <img
                          className="approved-icon"
                          src={successIcon}
                          alt="approved_icon"
                        />
                      )}
                      <h5 className="block-title">{t('kyc.address.title')}</h5>
                    </div>
                  </div>
                  {!approved && !showOnly && (
                    <div className="col title-col">
                      <Button
                        styling="secondary"
                        label={t('kyc.editButton')}
                        onClick={() => setActive()}
                      />
                    </div>
                  )}
                </div>
              )}
            </>
          ) : (
            <DocumentStatusInfo
              status={currentStatus}
              currentDocument={currentDocument}
            />
          )}
        </div>
      </div>
    </ProofOfAddressSC>
  );
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      uploadKycDocument: ActionCreators.uploadKycDocument,
      toggleInfoModal: ActionCreators.toggleInfoModal
    },
    dispatch
  );

export default withTranslation('pages')(
  connect(
    state => ({
      approved: state.user.kyc.approvedAddress,
      devices: state.devices,
      responsiveContentView: state.ui.responsiveContent,
      subtypes: state.user.kyc.subtypes,
      documents: state.user.kyc.documents
    }),
    mapDispatchToProps
  )(ProofOfAddress)
);
